import React from 'react';
import { 
  HelpCircle, 
  Clock, 
  Luggage, 
  AlertTriangle, 
  User, 
  ShieldCheck, 
  Globe, 
  Wallet 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Прибытие в аэропорт',
      description: 'Для внутренних рейсов — за 1,5-2 часа, для международных — за 2,5-3 часа до вылета.'
    },
    {
      icon: Luggage,
      title: 'Багаж и ручная кладь',
      description: 'Проверьте требования авиакомпании по весу и размерам. Обычно это до 23 кг для багажа и до 10 кг для ручной клади.'
    },
    {
      icon: AlertTriangle,
      title: 'Запрещенные предметы',
      description: 'Жидкости в ручной клади — не более 100 мл в одной емкости. Острые предметы необходимо сдавать в багаж.'
    },
    {
      icon: User,
      title: 'Регистрация на рейс',
      description: 'Онлайн-регистрация обычно открывается за 24-48 часов до вылета и закрывается за 1-3 часа.'
    },
    {
      icon: ShieldCheck,
      title: 'Документы',
      description: 'Для внутренних рейсов достаточно российского паспорта, для международных — загранпаспорт и виза (если требуется).'
    },
    {
      icon: Globe,
      title: 'Часовые пояса',
      description: 'Учитывайте разницу во времени, особенно при перелетах между дальними регионами России.'
    },
    {
      icon: Wallet,
      title: 'Бонусные программы',
      description: 'Накапливайте мили с помощью бонусных программ авиакомпаний для будущих бесплатных полетов.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Советы путешественникам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="w-5 h-5 text-amber-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-amber-700 dark:text-amber-300 mb-2">
              Будьте готовы к изменениям
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400 mb-3">
              Расписание рейсов может меняться из-за погодных условий и операционных причин.
              Рекомендуем проверять статус рейса перед вылетом на сайте авиакомпании или аэропорта.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;